import { getQueryParam, setQueryParam } from "../utils/queryParam";
import { bindStickySelectChange } from "./product";

customElements.define('kit-options',
  class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();

      this.accordionButton.addEventListener('click', () => {
        const isOpen = this.accordionButton.classList.toggle('active')
        this.accordionButton.setAttribute('aria-expanded', isOpen)
      })

      // Pills are <button>: Enter / Space trigger the click natively
      this.pills.forEach(pill => {
        pill.addEventListener('click', () => this.onPillSelect(pill))
      })

      // onVariantChange() replaces this element's own wrapper (.product-description--kit)
      // on every run, which disconnects and reconnects a fresh <kit-options> instance.
      // Bind the listener on the stable `.variants` node (never replaced) only once,
      // guarded by a dataset flag - otherwise each reconnect adds another listener and
      // the number of main-product-new fetches doubles on every subsequent change.
      const variants = this.productContainer.querySelector('.variants')
      if (variants && !variants.dataset.kitChangeBound) {
        variants.dataset.kitChangeBound = 'true'
        variants.addEventListener('change', () => {
          this.productContainer.querySelector('kit-options')?.onVariantChange()
        })
      }

      const index = Number(getQueryParam('kit') || '0')
      if (index !== 0 && this.pills[index]) this.onPillSelect(this.pills[index]);
    }

    init() {
      this.accordion = this.querySelector('.product-description--kit-accordion');
      this.accordionButton = this.accordion.querySelector('.variants--name');
      this.pills = this.querySelectorAll('.variant_pill-button');
      this.productContainer = document.querySelector('.product__container');

      window.kitOptions = window.kitOptions || {}
      if (!window.kitOptions[this.dataset.id]) window.kitOptions[this.dataset.id] = JSON.parse(this.querySelector('script[type="application/json"]').innerHTML)
      this.setNavigation();
    }

    async onPillSelect(pill) {
      this.productContainer.classList.add('loading-kit')

      this.pills.forEach(p => {
        p.classList.remove('selected')
        p.setAttribute('aria-pressed', 'false')
      })
      pill.classList.add('selected')
      pill.setAttribute('aria-pressed', 'true')
      const index = Number(pill.dataset.index);
      const data = window.kitOptions[this.dataset.id][index];

      setQueryParam('kit', index)

      // Hide/show accordion
      if (data.accordion) {
        this.accordion.removeAttribute('hidden');
        this.accordion.querySelector('.product-description--kit-accordion__content').innerHTML = data.accordion;
      } else this.accordion.setAttribute('hidden', '');

      // Set image
      let kitImage = this.productContainer.querySelector('.kit-image')
      const gallery = this.productContainer.querySelector('.product__media')
      if (index === 0) {
        kitImage?.remove()
        this.productContainer.classList.remove('mode-kit')
      } else {
        this.productContainer.classList.add('mode-kit');
        if (!kitImage) {
          kitImage = document.createElement('img')
          kitImage.classList.add('kit-image')
          gallery.appendChild(kitImage)
        }
        kitImage.src = data.image;
      }

      // Set rest content
      let html = data.html;
      if (!html) {
        html = await fetch(data.url + '&section_id=main-product-new')
          .then(r => r.text()).catch(() => '')
        window.kitOptions[this.dataset.id][index].html = html
      }
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      const newVariantId = doc.querySelector('input[name="id"]').value
      this.productContainer.querySelector('input[name="id"]').value = newVariantId
      const selectors = [
        '.product__description--variantform-button',
        '.product__description--price-stock',
        '.product__description--price-prices',
        '.product__description--badges',
        '.product__description .product__description--tags',
      ]
      selectors.forEach(selector => {
        const newElement = doc.querySelector(selector);
        const currentElement = this.productContainer.querySelector(selector)
        if (newElement && currentElement) this.productContainer.querySelector(selector).outerHTML = doc.querySelector(selector).outerHTML
        else if (!newElement && currentElement) currentElement.classList.add('hidden')
      })

      // Mirror the same state into the sticky nav add-to-cart bar
      await this.updateStickyNav(data)

      window.backInStockRegisterEvents();

      this.productContainer.classList.remove('loading-kit')
    }

    /**
     * Sync the top sticky nav bar (image, price, variant id and button state)
     * with the kit variant selected in the main product form.
     * Only swaps inner content, never the `#add-to-cart-form-sticky` element
     * itself, so the submit listener Cart.addToCart() bound to it on page
     * load (which enables AJAX add-to-cart without a page reload) survives.
     * @param {Object} data - Entry from window.kitOptions holding the kit's url/cache
     * @author Cristian Velasco <cristian@gradiweb.com>
     */
    async updateStickyNav(data) {
      const stickyContainer = document.querySelector('.navigation-bar-sticky .atc-component')
      if (!stickyContainer) return

      let stickyHtml = data.stickyHtml
      if (!stickyHtml) {
        stickyHtml = await fetch(data.url + '&section_id=sticky-navigation-bar')
          .then(r => r.text()).catch(() => '')
        data.stickyHtml = stickyHtml
      }
      if (!stickyHtml) return

      const newDoc = new DOMParser().parseFromString(stickyHtml, 'text/html')

      const swapInner = (selector) => {
        const newElement = newDoc.querySelector(selector)
        const currentElement = document.querySelector(selector)
        if (newElement && currentElement) currentElement.innerHTML = newElement.innerHTML
      }

      swapInner('.atc-component__product-image')
      swapInner('.atc-component__product-info')
      swapInner('#add-to-cart-form-sticky')

      bindStickySelectChange(document.querySelector('.navigation-bar-sticky select[name="id"]'))
    }

    onVariantChange() {
      this.classList.add('loading-kit');

      setTimeout(async () => {
        setQueryParam('kit', 0)

        // Remove image
        let kitImage = this.productContainer.querySelector('.kit-image')
        const gallery = this.productContainer.querySelector('.product__media')
        kitImage?.remove()
        gallery.classList.remove('mode-kit')

        const newId = this.productContainer.querySelector('input[name="id"]').value;
        let html = window.kitOptions[newId]?.[0]?.html
        if (!html) {
          html = await fetch(`${location.pathname}?variant=${newId}&section_id=main-product-new`)
            .then(r => r.text()).catch(() => '')
        }
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        doc.querySelector('.product-description--kit kit-options').removeAttribute('hidden')
        this.productContainer.querySelector('.product-description--kit').outerHTML = doc.querySelector('.product-description--kit').outerHTML
      }, 0)
    }

    setNavigation() {
      const btn = this.querySelector('.kit-pills-navigation')
      const track = this.querySelector('.variants--pill-container')
      if (!track || !btn || window.innerWidth < 990) return

      const updateClasses = () => {
        const canScrollLeft = track.scrollLeft > 0
        const canScrollRight = track.scrollLeft + track.clientWidth < track.scrollWidth - 1

        btn.classList.toggle('active-prev', canScrollLeft)
        btn.classList.toggle('active-next', canScrollRight)
        // Same rule as the click handler below: scrolls left when possible
        btn.setAttribute('aria-label', canScrollLeft ? btn.dataset.labelPrev : btn.dataset.labelNext)
      }

      btn.addEventListener('click', () => {
        const canScrollLeft = track.scrollLeft > 0
        track.scrollBy({ left: canScrollLeft ? -200 : 200, behavior: 'smooth' })
      })

      track.addEventListener('scroll', updateClasses)
      updateClasses()
    }
  }
);